export interface IDeviceMgmt {
  uid: number;
  group?: number;
  lat?: number;
  lon?: number;
  imei?: number;
  deviceType?: string;
}

export class DeviceMgmt implements IDeviceMgmt {
  constructor(
    public uid: number,
    public group?: number,
    public lat?: number,
    public lon?: number,
    public imei?: number,
    public deviceType?: string
  ) {}
}
